import { CloseIcon } from "@/components/features/SquadBuilder/RightPanel/PanelHeader/PanelHeader";

export type TacticsSidePanelOption = "filters" | "chosenTactic";

const sidebarOptionsLabel = {
  filters: "Filters",
  chosenTactic: "Tactic Template",
};

interface TacticsSidebarProps {
  children: React.ReactNode;
  sidebarOption: TacticsSidePanelOption;
  handleCloseSidebar: () => void;
}

const TacticsSidebar = ({
  sidebarOption,
  children,
  handleCloseSidebar,
}: TacticsSidebarProps) => {
  // Phones get the bottom sheet instead, so this only ever renders from the
  // `mobile` breakpoint (769px) up — every class here is that side of it.
  return (
    <article className="flex flex-col w-full shrink-0 desktop:w-[278px] touch-device:rounded-lg desktop:mb-2 bg-panel-background shadow-side-panel desktop:overflow-y-auto min-h-50">
      <section className="flex flex-row items-center justify-between h-12">
        <div className="w-8" /> {/* For positioning */}
        <p className="text-sm text-white font-semibold desktop:font-normal">
          {sidebarOptionsLabel[sidebarOption]}
        </p>
        <button className="p-2" onClick={handleCloseSidebar}>
          <CloseIcon />
        </button>
      </section>
      {children}
    </article>
  );
};

export default TacticsSidebar;
